ceregoCommon.factory('UserSeriesCollaboratorsResource', ['$resource', ($resource) ->
  $resource "",{},
    query:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_user_goal_list_contributors_path(":user_id")
      params:
        series_id: "@user_id"
])
